jQuery(document).ready(function ($) {
  const products_on_page = document.getElementById("product-grid");
  if (!products_on_page || !$.scrollify) return;
  const nextUrlElement = document.getElementById("paginateNext");
  let next_url = nextUrlElement ? nextUrlElement.dataset.nextUrl : "";

  let actualProductCount = products_on_page.getElementsByClassName("grid__item").length;

  let currentPage = 1;

  // Get Load More button and Product container
  const $loadMoreButton = $("#loadMore");
  const $productContainer = $("#product-container");

  // Add click event listener for "Load More" button
  $loadMoreButton.on("click", function () {
    loadMoreProductsOnClick(currentPage);
  });

  async function getNextPage(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (error) {
      console.error("Failed to fetch next page:", error);
    }
  }

  async function loadMoreProductsOnClick(page) {
    // Disable the Load More button to prevent multiple clicks while loading
    $loadMoreButton.prop("disabled", true).text("Loading...");

    if (!next_url) {
      document.getElementById("loadMore").innerHTML = "No more products...";
      console.warn("No more pages to load.");
      return;
    }

    const nextPage = await getNextPage(next_url);
    if (!nextPage) return;

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, "text/html");

    const newUrlElement = nextPageDoc.getElementById("paginateNext");
    next_url = newUrlElement ? newUrlElement.dataset.nextUrl : "";

    const productGrid = nextPageDoc.getElementById("product-grid");
    if (productGrid) {
      const newProducts = productGrid.getElementsByClassName("grid__item");
      for (const product of newProducts) {
        products_on_page.appendChild(product.cloneNode(true));
        actualProductCount++;
      }
    }

    setTimeout(function () {
      // Enable the Load More button again
      $loadMoreButton.prop("disabled", false).text("Load More");

      // Increment the page number for next load
      currentPage++;

      // Scroll only after explicit "Load more" interaction.
      const loadSection = document.getElementById("load-section");
      if (loadSection) {
        loadSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 1000);
  }

  const $sortWrapper = $(".facet-filters__sort");

  $sortWrapper.on("change", function () {
    setTimeout(function () {
      location.reload();
    }, 1000);

    getNextPage(next_url);
    $loadMoreButton.prop("disabled", false).text("Load More");
  });

  const $filterWrapper = $("#FacetsWrapperDesktop");

  $filterWrapper.on("click", function () {
    // setTimeout(function() {
    //     location.reload();
    //     }, 1000);

    getNextPage(next_url);
    $loadMoreButton.prop("disabled", false).text("Load More");
  });
});
